import React from "react";
import partner from "../assets/clients/sale1.jpeg";

const AuthorizedSales = () => (
  <section className="py-12 md:py-20 bg-white border-b border-slate-200 relative">
    <div className="max-w-7xl mx-auto px-5 lg:px-8">

      {/* header */}
      <div className="text-center mb-8 md:mb-12" data-aos="fade-up">
        <div className="mb-3">
          <span className="text-blue-600 font-bold tracking-widest uppercase text-[10px] border-b-2 border-orange-500 pb-1">
            Partners
          </span>
        </div>
        <h2 className="text-2xl sm:text-3xl md:text-4xl lg:text-5xl font-teko uppercase text-slate-900 tracking-wide">
          Our Authorized Sales &amp; Service Partners
        </h2>
      </div>

      {/* card */}
      <div
        className="flex flex-col md:flex-row items-center bg-slate-50 border border-slate-200 rounded-xl shadow-sm hover:shadow-md transition-shadow duration-300 w-full max-w-4xl mx-auto overflow-hidden"
        data-aos="fade-up"
        data-aos-delay="100"
      >
        {/* logo */}
        <div className="w-full md:w-2/5 h-44 md:h-auto flex items-center justify-center p-6 md:p-8 border-b md:border-b-0 md:border-r border-slate-200 bg-white">
          <img
            className="object-contain max-h-full max-w-full"
            src={partner}
            alt="Reckonix Sales Partner"
          />
        </div>

        {/* details */}
        <div className="w-full md:w-3/5 p-6 md:p-8 lg:p-12">
          <h3 className="text-2xl md:text-3xl font-teko uppercase tracking-wider text-blue-700 mb-4 md:mb-6">
            Reckonix
          </h3>
          <div className="space-y-3 md:space-y-4 text-slate-700 font-medium">
            <p className="flex items-start gap-3 md:gap-4">
              <svg
                className="w-5 h-5 md:w-6 md:h-6 text-orange-500 mt-0.5 flex-shrink-0"
                fill="none"
                stroke="currentColor"
                viewBox="0 0 24 24"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth="2"
                  d="M17.657 16.657L13.414 20.9a1.998 1.998 0 01-2.827 0l-4.244-4.243a8 8 0 1111.314 0z"
                />
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth="2"
                  d="M15 11a3 3 0 11-6 0 3 3 0 016 0z"
                />
              </svg>
              <span className="leading-relaxed text-xs md:text-sm lg:text-base">
                Unit F2, MIDC Plot no. BG/PAP3,
                <br />Opp. The Fern Residency Hotel, MIDC, Bhosari,
                <br />Pune-411026, Maharashtra
              </span>
            </p>

            <p className="flex items-center gap-3 md:gap-4">
              <svg
                className="w-5 h-5 md:w-6 md:h-6 text-orange-500 flex-shrink-0"
                fill="none"
                stroke="currentColor"
                viewBox="0 0 24 24"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth="2"
                  d="M3 5a2 2 0 012-2h3.28a1 1 0 01.948.684l1.498 4.493a1 1 0 01-.502 1.21l-2.257 1.13a11.042 11.042 0 005.516 5.516l1.13-2.257a1 1 0 011.21-.502l4.493 1.498a1 1 0 01.684.949V19a2 2 0 01-2 2h-1C9.716 21 3 14.284 3 6V5z"
                />
              </svg>
              <a
                href="tel:7095521126"
                className="hover:text-blue-600 transition-colors text-xs md:text-sm lg:text-base"
              >
                7095521126
              </a>
            </p>

            <p className="flex items-center gap-3 md:gap-4">
              <svg
                className="w-5 h-5 md:w-6 md:h-6 text-orange-500 flex-shrink-0"
                fill="none"
                stroke="currentColor"
                viewBox="0 0 24 24"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth="2"
                  d="M3 8l7.89 5.26a2 2 0 002.22 0L21 8M5 19h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z"
                />
              </svg>
              <a
                href="mailto:sales@reckonix.in"
                className="hover:text-blue-600 transition-colors text-xs md:text-sm lg:text-base"
              >
                sales@reckonix.in
              </a>
            </p>
          </div>
        </div>
      </div>
    </div>
  </section>
);

export default AuthorizedSales;
